import { render, staticRenderFns } from "./CampaignsRatioCharts.vue?vue&type=template&id=68694d53"
import script from "./CampaignsRatioCharts.vue?vue&type=script&lang=js"
export * from "./CampaignsRatioCharts.vue?vue&type=script&lang=js"
import style0 from "./CampaignsRatioCharts.vue?vue&type=style&index=0&id=68694d53&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports